import { useMsalOptions } from '@vivli/core/infrastructure/hook';
import { IContextWrapper } from '@vivli/shared/infrastructure/interface';
import { PlatformContextInitWrapper } from './platform-context-init.wrapper';
import { useEffect, useRef, useState } from 'react';
import { createStandardPublicClientApplication, IPublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { PlatformAuthContextWrapper } from './platform-auth-context.wrapper';

export const PlatformMsalInitWrapper = ({ children }: IContextWrapper) => {
    const [pca, setPca] = useState<IPublicClientApplication>(null);
    const initRef = useRef(false);

    const { options } = useMsalOptions();

    useEffect(() => {
        if (initRef.current) return;

        initRef.current = true;
        createStandardPublicClientApplication(options.config).then(setPca);
    }, []);

    if (!pca) {
        return null;
    }

    return (
        <MsalProvider instance={pca}>
            <PlatformAuthContextWrapper>
                <PlatformContextInitWrapper>{children}</PlatformContextInitWrapper>
            </PlatformAuthContextWrapper>
        </MsalProvider>
    );
};
